import React from "react";
import themeStyles from "../../../shared/styles/theme/theme-styles.module.scss";
import InputGroup from "../../components/inputGroup/InputGroup";
import "./forgetPasswordBox.scss";

const ForgetPasswordForm = (props) => {
  const handleSubmit = (e) => {
    e.preventDefault();
    props.setFieldTouched("email", true);
    if (
      Object.keys(props.touched).length > 0 &&
      !Object.keys(props.errors).length > 0
    ) {
      props.handleSubmit(email);
    }
  };
  const { handleChange, onCancel, handleBlur, errors, values, touched } = props;
  const { email } = values;

  return (
    <form>
      <InputGroup
        id="email"
        name="email"
        label={"E-mail"}
        inputValue={email}
        onChange={handleChange}
        onBlur={handleBlur}
        className="formGroupLogin"
        errors={errors}
        touched={touched}
      />
      <div className="formGroupForget">
        <div className="row">
          <label
            className="rememberMeCbText"
            onClick={onCancel}
            style={{ cursor: "pointer" }}
          >
            Cancel
          </label>
          <button
            className={`${themeStyles.btnContained}`}
            onClick={handleSubmit}
          >
            Send password reset link
          </button>
        </div>
      </div>
    </form>
  );
};
export default ForgetPasswordForm;
